import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserMaster } from "../types";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";

interface ISessionState {
    user: UserMaster | null;
}

const initialState: ISessionState = {
    user: null,
};

export const sessionSlice = createSlice({
    name: "session",
    initialState,
    reducers: {
        setUser: (state, action: PayloadAction<UserMaster | null>) => {
            return {
                ...state,
                user: action.payload,
            };
        },
    },
});

export const { setUser } = sessionSlice.actions;
const persistConfig = {
    key: "session",
    storage,
};
export default persistReducer(persistConfig, sessionSlice.reducer);
